'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
require('magnific-popup');
const Route = require('common/route');
const ElementCommunication = require('./element-communication');
const ElementMention = require('system/util/element-mention');
const ElementAction = require('system/domain/action/element');
const DiagramRepository = require('system/domain/repository/diagram');
const ElementRepository = require('system/domain/repository/element');
const TagRepository = require('system/domain/repository/tag');
const NodeModel = require('system/domain/entity/node');
const SyncStatesModel = require('system/domain/entity/sync-states');
const Template = require('system/ui/template/detail/node-info.hbs');
const SyncStateView = require('system/ui/view/sync-state');
const ElementDescriptionViewerView = require('system/ui/view/detail/description-viewer');
const LinkedNodeListView = require('system/ui/view/detail/linked-node-list');
const LinkedNodeDiagramView = require('system/ui/view/detail/linked-node-diagram');
const OwnerListView = require('system/ui/view/detail/owner-list');
const RemoteLinkListView = require('system/ui/view/detail/remote-link-list');
const TagListView = require('system/ui/view/detail/tag-list');
const ValuePropertyListView = require('system/ui/view/detail/value-property-list');
const Marked = require('balus/util/marked');

const NodeInfoView = Mn.View.extend({
    model: NodeModel,
    template: Template,
    className: 'node-info',
    regions: {
        description: '.description-wrapper',
        values: '.values .detail-item-content',
        tag: '.tags',
        owner: '.owners',
        linkedNodeListInout: '.linked-node-list-inout',
        linkedNodeListOut: '.linked-node-list-out',
        linkedNodeListIn: '.linked-node-list-in',
        linkedNodeDiagram: '.linked-node-diagram',
        remoteLinks: '.remote-links',
        syncState: '.sync-states',
        nav: '.nav',
        navContent: '.nav-content'
    },
    ui: {
        diagramSelector: '.diagram-selector li',
        diagramSelectorLink: '.diagram-selector li a'
    },
    events: {
        'click .add-comment': 'addComment',
        'click .filter-comment': 'filterComment',
        'click .enter-edit': 'startEdit',
        'click .move-to': 'moveTo',
        'click @ui.diagramSelector': 'onSelectDiagram',
        'click @ui.diagramSelectorLink': 'onSelectDiagramLink',
        'click .close-pane': function(){this.trigger('hide')}
    },

    initialize: function(params) {
        this._diagram = params.diagram;
        this._context = this.getOption('context');
        this._channel = this.getOption('channel');

        this.listenTo(this.model, 'change:edit',
            this.trigger.bind(this, 'change:edit'));
        // this.listenTo(MemberRepository.getMembers({
        //     context: this._context
        // }), 'add', this.render);
        this.listenTo(TagRepository.getTags({
            context: this._context
        }), 'add', this.render);
        this.listenTo(this._diagram.getNodeMeta(this.model.id),
            'remove', this.remove);
    },

    serializeData: function() {
        const json = this.model.toJSON();
        const model = this.model;
        const members = this.getOption('group').getMembers();

        const diagrams = DiagramRepository.getDiagrams({
            context: this._context
        })
            .chain()
            .filter(function(d) {
                return d.hasElement(model);
            })
            .map(function(d) {
                const j = d.toJSON();
                j.url = Route.urlFor(
                        'path:diagram', d.idParams())
                    + Route.urlFor(
                        'diagram:element', {id: model.id});
                if(this._context.diagramId ==
                    d.get('diagram_id')) {
                    j.currentDiagram = true;
                }
                return j;
            }, this)
            .value();

        json['editable'] = this.getOption('auth').isNodeDetailEditable();
        json['description'] = Marked()(json['description']);
        json['hasDescription'] = this.model.get('description');
        json['hasValues'] = this.model.get('values') && this.model.get('values').length > 0;
        json['hasOwners'] = members.getMembersByUserId(this.model.get('owners')).length > 0;
        json['hasTags'] = TagRepository.getTags({
                context: this._context})
                .getByIds(this.model.get('tags')).length > 0;
        json['type'] = this.model.i18nType();
        if(diagrams.length > 1) {
            json['diagrams'] = diagrams;
        }

        return json;
    },

    onRender: function() {
        const members = this.getOption('group').getMembers();

        if (this.model.get('description')) {
            const descriptionViewer = new ElementDescriptionViewerView();
            const json = this.model.toJSON();
            json['description'] = Marked()(json['description']);
            $('#modal-container').append(
                descriptionViewer.render(json).el);
        }
        this.$('.description, .description-content').magnificPopup({
            delegate: 'p:parent img',
            type: 'image',
            gallery: {enabled: true},
            callbacks: {
                elementParse: function (item) {
                    item.src = item.el.attr('src');
                }
            }
        });

        this.$('.description, .description-content').externalLinkTargetBlank();

        // values
        const valueCollection = new Backbone.Collection(this.model.get('values'));
        const valuePropertyListView = new ValuePropertyListView({
            collection: valueCollection,
            context: this._context
        });
        this.showChildView('values', valuePropertyListView);

        // tag
        this.showChildView('tag', new TagListView({
            collection: new Backbone.Collection(
                TagRepository.getTags({
                    context: this._context
                }).getByIds(this.model.get('tags'))
            ),
            context: this._context
        }));

        // owner
        this.showChildView('owner', new OwnerListView({
            collection: new Backbone.Collection(
                members.getMembersByUserId(this.model.get('owners'))
            ),
            context: this._context
        }));

        // linked nodes
        this.$(`.linked-node-collapse-${this.model.id}`).on('show.bs.collapse', () => {
            this._openDiagramLink = true;
            this.renderLinkedNode(this._diagram);
            this.$('.collapse-icon').removeClass('fa-angle-down');
            this.$('.collapse-icon').addClass('fa-angle-up');
        });
        this.$(`.linked-node-collapse-${this.model.id}`).on('hide.bs.collapse', () => {
            this._openDiagramLink = false;
            this.$('.collapse-icon').removeClass('fa-angle-up');
            this.$('.collapse-icon').addClass('fa-angle-down');
        });

        // remote link
        // this.showChildView('remoteLinks', new RemoteLinkListView({
        //     node: this.model,
        //     edit: false,
        //     diagram: this._diagram,
        //     context: this._context
        // }));

        // sync state
        this.showChildView('syncState', new SyncStateView({
            model: new SyncStatesModel({
                models: [
                    this.model.syncState,
                    this._diagram.getNodeMeta(
                        this.model.id).syncState
                ]
            })
        }));

        (new ElementMention(this._context, this._channel)).addClickHandler($(this));


        this.showChildView('navContent', new ElementCommunication({
            model: this.model,
            context: this.getOption('newContext'),
            parentContent: this.$('.content'),
            navRegion: this.getRegion('nav')
        }));

        return this;
    },

    addComment: function() {
        this.trigger('add:comment', this.model);
    },

    filterComment: function() {
        this.trigger('filter:comment',
            this.model.toString({idLength: 10}) + ' ');
    },

    startEdit: function() {
        ElementAction.startEditNode({
            context: this._context,
            node: {id: this.model.id}
        });
    },

    moveTo: function() {
        this._channel.request('canvas:zoomTo', this.model);
    },

    onSelectDiagram: function(e) {
        if(this._selectDiagramLink) {
            return;
        }
        const id = $(e.currentTarget).attr('diagram-id');
        this.ui.diagramSelector.removeClass('is-active');
        $(e.currentTarget).addClass('is-active');
        if (this._openDiagramLink) {
            const diagram = DiagramRepository.getDiagrams({context: this._context}).get(id);
            this.renderLinkedNode(diagram);
        }
    },

    onSelectDiagramLink: function(e) {
        this._selectDiagramLink = true;
    },

    renderLinkedNode: function(diagram) {
        const inoutRecords = new Backbone.Collection();
        const outRecords = new Backbone.Collection();
        const inRecords = new Backbone.Collection();
        const relations = ElementRepository.getLinks({
            context: this._context
        }).clone();
        const members = this.getOption('group').getMembers();

        relations.reset([]);
        relations.add(ElementRepository
            .getLinks({context: this._context})
            .getLinksHasEdgeOf(this.model.id));
        relations.each(function(relation) {
            if(!diagram.hasLink(relation)) {
                return;
            }
            inRecords.add(relation.source);
            outRecords.add(relation.target);
        });
        inRecords.remove(this.model, {silent: true});
        outRecords.remove(this.model, {silent: true});
        const inout = _.intersection(inRecords.models, outRecords.models);
        inoutRecords.add(inout);
        inRecords.remove(inout, {silent: true});
        outRecords.remove(inout, {silent: true});

        this.showChildView('linkedNodeDiagram',
            new LinkedNodeDiagramView({
                diagram: diagram,
                context: this._context,
                auth: this.getOption('auth'),
                size: {
                    width: 200,
                    height: 200
                },
                record: this.model,
                members: members,
                inoutRecords: inoutRecords,
                outRecords: outRecords,
                inRecords: inRecords,
                relations: relations
            }));

        _.each([
            {
                region: this.getRegion('linkedNodeListInout'),
                indexPrefix: 'io',
                collection: inoutRecords
            },
            {
                region: this.getRegion('linkedNodeListOut'),
                indexPrefix: 'o',
                collection: outRecords
            },
            {
                region: this.getRegion('linkedNodeListIn'),
                indexPrefix: 'i',
                collection: inRecords
            }
        ], function(p) {
            p.region.show(
                new LinkedNodeListView({
                    collection: p.collection,
                    node: this.model,
                    links: relations,
                    diagram: diagram,
                    channel: this._channel,
                    indexPrefix: p.indexPrefix
                }));

            if(p.collection.length == 0) {
                p.region.$el.parent().hide();
            } else {
                p.region.$el.parent().show();
            }
        }, this);
    }
});

module.exports = NodeInfoView;



// WEBPACK FOOTER //
// ./system/ui/view/detail/node-info.js